import { useState, useRef } from "react";
import SearchInput from "./SearchInput";

## Basic Usage

export function BasicSearchInput() {
  const [query, setQuery] = useState("");
  return (
    <SearchInput
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      clearSearch={() => setQuery("")}
      placeholder="Search..."
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <BasicSearchInput />
</div>

---

## Full Width

export function FullWidthSearch() {
  const [query, setQuery] = useState("");
  return (
    <SearchInput
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      clearSearch={() => setQuery("")}
      placeholder="Search everything..."
      fullWidth
    />
  );
}

<FullWidthSearch />

---

## Sizes

<div style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "300px" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Medium:**</p>
    <SearchInput size="medium" clearSearch={() => {}} placeholder="Medium" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Medium Large:**</p>
    <SearchInput size="mediumLarge" clearSearch={() => {}} placeholder="Medium Large" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Large:**</p>
    <SearchInput size="large" clearSearch={() => {}} placeholder="Large" />
  </div>
</div>

---

## Transparent Style

<div style={{ background: "#f5f5f5", padding: "1rem", borderRadius: "8px", maxWidth: "300px" }}>
  <SearchInput clearSearch={() => {}} placeholder="Transparent search" transparent />
</div>

---

## With Search Query State

export function SearchWithState() {
  const [query, setQuery] = useState("example search");
  return (
    <div>
      <SearchInput
        searchQuery={query}
        onChange={(e) => setQuery(e.target.value)}
        clearSearch={() => setQuery("")}
        placeholder="Type to search..."
      />
      <p style={{ marginTop: "0.5rem", fontSize: "14px", color: "#666" }}>
        Query: "{query}"
      </p>
    </div>
  );
}

<div style={{ maxWidth: "300px" }}>
  <SearchWithState />
</div>

---

## Header Style

The header style is optimized for use in application headers.

<div style={{ background: "#1a1a2e", padding: "1rem", borderRadius: "8px" }}>
  <SearchInput
    clearSearch={() => {}}
    placeholder="Search..."
    isInHeader
  />
</div>

---

## Search with Results

export function SearchWithResults() {
  const [query, setQuery] = useState("");
  const items = ["Apple", "Banana", "Cherry", "Date", "Elderberry", "Fig", "Grape"];
  const filtered = query ? items.filter((i) => i.toLowerCase().includes(query.toLowerCase())) : [];
  return (
    <div style={{ position: "relative" }}>
      <SearchInput
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        clearSearch={() => setQuery("")}
        placeholder="Search fruits..."
      />
      {query && (
        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#fff", border: "1px solid #e5e5e5", borderRadius: "4px", marginTop: "4px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
          {filtered.length > 0 ? (
            filtered.map((item) => (
              <div key={item} style={{ padding: "8px 12px", cursor: "pointer" }} onClick={() => { setQuery(item); }}>
                {item}
              </div>
            ))
          ) : (
            <div style={{ padding: "8px 12px", color: "#666" }}>No results found</div>
          )}
        </div>
      )}
    </div>
  );
}

<div style={{ maxWidth: "300px" }}>
  <SearchWithResults />
</div>

---

## In a Toolbar

<div style={{ display: "flex", alignItems: "center", gap: "1rem", padding: "0.75rem", background: "#fafafa", borderRadius: "8px" }}>
  <span style={{ fontWeight: 500 }}>Files</span>
  <div style={{ flex: 1, maxWidth: "250px" }}>
    <SearchInput clearSearch={() => {}} placeholder="Search files..." size="medium" />
  </div>
  <button style={{ padding: "6px 12px", background: "#3b82f6", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" }}>
    New
  </button>
</div>


